export default "__VITE_ASSET__BB55nrzx__"